import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0047AB',
            dark: '#003585',
            contrastText: '#ffffff',
        },
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        backgroundColor: '#F7F6FF',
                        borderRadius: 5,
                        height: '30px',
                        marginTop: '10px',
                        fontSize: '10px',
                        fontWeight: '400',
                    },
                },
            },
        },
    },
});

export default theme;
